import { render, staticRenderFns } from "./WidgetBanner.vue?vue&type=template&id=497ae2d1&scoped=true"
import script from "./WidgetBanner.vue?vue&type=script&lang=js"
export * from "./WidgetBanner.vue?vue&type=script&lang=js"
import style0 from "./WidgetBanner.vue?vue&type=style&index=0&id=497ae2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ae2d1",
  null
  
)

export default component.exports